import React from 'react';

export default () => (
  <svg width="68" height="47" viewBox="-1 -1 70 49" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(1)">
          <path fill="#D6DCE4" d="M.5.5h64.786V45H.5z" />
          <circle stroke="#FFF" strokeWidth="2" cx="53" cy="12" r="6" />
          <path
            d="M.571 32.256l19-18 25 30.5M38.571 37.256L49.711 27 65.5 41.256"
            stroke="#FFF"
            strokeWidth="2"
            strokeLinecap="square"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/media-preview-widget.es6.js